'use client';

const Nbsp = () => <span>&nbsp;</span>;

export default Nbsp;
